export default "__VITE_ASSET__61c0ef5e__"